<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Bulk Edit Line Item</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <form
      [formGroup]="form"
      class="invoice-note-form__wrapper"
      (submit)="onSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Unit Cost</label>
            <input
              type="number"
              inputmode="numeric"
              class="lum-input"
              formControlName="purchasePrice"
              matInput
            />
            <mat-error *ngIf="form.get('purchasePrice')?.invalid">
              {{ form.get('purchasePrice') | validateField }}
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Purchase Qty.</label>
            <input
              type="number"
              inputmode="numeric"
              class="lum-input"
              formControlName="purchaseQty"
              matInput
              lumDecimalLimit
            />
          </div>
          <mat-error *ngIf="form.get('purchaseQty')?.invalid">
            {{ form.get('purchaseQty') | validateField }}
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Add to Receiving Qty.</label>
            <input
              type="number"
              inputmode="numeric"
              class="lum-input"
              formControlName="addToReceivingQty"
              matInput
              lumDecimalLimit
            />
          </div>
          <mat-error *ngIf="form.get('purchaseQty')?.invalid">
            {{ form.get('purchaseQty') | validateField }}
          </mat-error>
        </div>
      </div>
      <div class="lum-modal__footer">
        <div class="flex ml-auto lum-modal__action">
          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="form.invalid"
          >
            Update
            <lum-ui-icon
              class="ml-2-5"
              icon="content-save"
              color="#ffffff"
              width="23"
              height="23"
            ></lum-ui-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
